export enum AccessIntroMembershipEnum {
  First = 'first',
  Family = 'family,',
  Re = 're',
}
